export default {
	params: {},
	config(params) {
		this.params = params
	},
	setFunctions(functions) {
		Object.assign(this, functions)
	}
}
